import {
  CELL_SIZE,
  DIRECTION_DOWN,
  DIRECTION_LEFT,
  DIRECTION_RIGHT,
  DIRECTION_UP,
} from "../helpers/consts";

export class Camera {
  constructor(level) {
    this.level = level;
    this.cameraX = this.level.heroRef.x * CELL_SIZE;
    this.cameraY = this.level.heroRef.y * CELL_SIZE;
    this.transformOffset = 5.5 * -CELL_SIZE;
  }

  static lerp(startValue, destinationValue, time) {
    return startValue * (1 - time) + destinationValue * time;
  }

  get transformX() {
    return -this.cameraX - this.transformOffset + "px";
  }

  get transformY() {
    return -this.cameraY - this.transformOffset + "px";
  }

  tick() {
    const hero = this.level.heroRef;
    let cameraDestinationX = hero.x;
    let cameraDestinationY = hero.y;

    if (hero.movingPixelsRemaining > 0) {
      if (hero.movingPixelDirection === DIRECTION_DOWN) {
        cameraDestinationY += 1.5;
      }
      if (hero.movingPixelDirection === DIRECTION_UP) {
        cameraDestinationY -= 1.5;
      }
      if (hero.movingPixelDirection === DIRECTION_LEFT) {
        cameraDestinationX -= 1.5;
      }
      if (hero.movingPixelDirection === DIRECTION_RIGHT) {
        cameraDestinationX += 1.5;
      }
    }

    cameraDestinationX *= CELL_SIZE;
    cameraDestinationY *= CELL_SIZE;

    this.cameraX = Camera.lerp(this.cameraX, cameraDestinationX, 0.05);
    this.cameraY = Camera.lerp(this.cameraY, cameraDestinationY, 0.05);
  }
}
